import { useEffect, useRef } from 'react';
import { useDispatch } from 'umi';

type TrendingLoadKey = 'trendingVideo' | 'trendingPosts';

/**
 * Trending 子组件首次加载完成通知 Hook
 *
 * 监听 loading 状态，在首次加载完成时 dispatch 到 opinionOrderLoading model，
 * 供父组件判断两个子组件是否都加载完成，以便延迟恢复滚动位置。
 *
 * @param key - model 中的 loading key
 * @param loading - 子组件的 loading 状态
 *
 * @example
 * ```tsx
 * const { data, loading } = useTrendingRequest({...});
 * useTrendingLoading('trendingVideo', loading);
 * ```
 */
export function useTrendingLoading(key: TrendingLoadKey, loading: boolean) {
  const dispatch = useDispatch();
  const hasLoadedRef = useRef(false); 

  // 首次加载完成时设为 1
  useEffect(() => {
    if (!loading && !hasLoadedRef.current) {
      hasLoadedRef.current = true;
      dispatch({ type: 'opinionOrderLoading/change', key, value: 1 });
    }
  }, [loading, dispatch, key]);
}
